import { createSelector } from '@reduxjs/toolkit';

import { convertMapBoundsToBbox } from '@/microfrontends/map/shared/utils/map/convertMapBoundsToBbox';

import { type IBBoxSchema } from '@/repositories/generated/shared/search-offers-index/entities/bbox/BBoxSchema';

import { useReduxSelector } from '../../../hooks';

import { mapConfigurationBoundsSelector } from './dumb';

export const mapConfigurationBboxSelector = createSelector(mapConfigurationBoundsSelector, bounds =>
  convertMapBoundsToBbox(bounds),
);

export function useMapConfigurationBboxSelector(): IBBoxSchema {
  return useReduxSelector(mapConfigurationBboxSelector);
}
